<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSS_VA_QR_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h2 class="title_h">Quản lý QR VA</h2>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.virtualAccount"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.lotIn"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã lô"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.regionCode" :options="dataConfigRegion" placeholder="Vùng" />
          </div>

          <!-- <div class="form-group">
            <Select2
              v-model="filters.businessProvinceCode"
              :options="dataProvince"
              :disabled="
                !filters.businessRegionCode ||
                filters.businessRegionCode === '0'
              "
              placeholder="Tỉnh/Thành phố kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.managerStaffId"
              :options="listUser"
              placeholder="Quản lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.staffId"
              :options="listUser"
              placeholder="Nhân viên chăm sóc"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.mcLvl"
              :options="listMcType"
              placeholder="Cấp bậc merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.regionCode"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event)"
              placeholder="Vùng merchant"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.districtCode"
              :options="dataDistrict"
              placeholder="Quận/Huyện merchant"
              :disabled="!filters.provinceCode || filters.provinceCode === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.mainBusinessMcc"
              :options="dataConfigMcc"
              placeholder="Ngành nghề"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.ownershipType"
              :options="ownershipType"
              placeholder="Loại hình sở hữu"
            />
          </div> -->

          <!-- <div class="form-group">
            <Select2
              v-model="filters.status"
              :options="listMcStatus"
              placeholder="Trạng thái MA"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.mobileUser"
              class="form-control f12 hc-37 text-search"
              placeholder="Tìm Mobile User"
            />
          </div> -->
          <div class="form-group">
            <Select2
              v-model="filters.qrRequesterBy"
              :options="listUser"
              placeholder="Người yêu cầu tạo QR"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.isUsed"
              :options="[
                { id: '0', text: 'Tất cả' },
                { id: 'true', text: 'Đã sử dụng' },
                { id: 'false', text: 'Chưa sử dụng' },
              ]"
              placeholder="Đã sử dụng"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.status" :options="listQrStatus" placeholder="Trạng thái QR" />
          </div>
          <!-- <div class="form-group">
            <Select2
              v-model="filters.integratedMethod"
              :options="[
                { id: '0', text: 'Tất cả' },
                { id: 'VAMC', text: 'VA trực tiếp' },
                { id: 'VANP', text: 'VA gián tiếp' }
              ]"
              placeholder="VA mode"
            />
          </div> -->
          <div class="form-group">
            <Select2 v-model="filters.bankCode" :options="listBankCode" placeholder="Ngân hàng" />
          </div>
          <div class="form-group">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
            <!-- <button type="button" @click="onAssignHandle" class="btn btn-outline-info hc-37 mr-2 pt-2"
              data-toggle="tooltip" data-placement="top" title="Gán nhân viên" :disabled="!hasCheckeds">
              Gán nhân viên
            </button> -->
          </div>
          <div class="form-group">
            <button
              type="button"
              class="btn btn-outline-info hc-37 mr-2 pt-2 dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style="min-width: 200px !important; position: relative"
              v-if="dataPermission && dataPermission.includes('CNPS_CSS_VA_QR_REQUEST_CREATE_QR')"
              :disabled="!hasCheckeds || isLoadingQr"
            >
              {{ isLoadingQr ? 'Loading...' : 'In mã QR code' }}
            </button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                v-for="(item, index) in listPrintQr"
                :key="index"
                href="#"
                @click="onPrintQrHandle(item?.id)"
                >{{ item?.text }}</a
              >
            </div>
          </div>
          <div class="form-group">
            <button
              @click="showRequestQrModal"
              style="min-width: 200px !important"
              class="btn btn-outline-primary hc-37 mr-2 pt-2"
            >
              Yêu cầu tạo QR
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header">
                <TotalCount :totals="totalCount" :data="totals" />
                <!-- Tổng số tài khoản: <strong class="text-primary">{{ totals.suspend + totals.active }}</strong>
                &nbsp;&nbsp;| &nbsp;&nbsp;
                Hoạt động: <strong class="text-success">{{ totals.active }}</strong> &nbsp;&nbsp;| &nbsp;&nbsp;
                Bị khóa: <strong class="text-danger">{{ totals.suspend }}</strong> -->
              </div>
            </div>
            <b-table
              hover
              sticky-header
              head-variant="light"
              responsive
              :items="dataTable"
              :fields="fields"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>

              <template #head(checkbox)>
                <b-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                  :disabled="isLoading || checkAllMSBVA"
                />
              </template>
              <template #cell(checkbox)="{ item }">
                <!-- <b-form-checkbox v-model="item.checked" :disabled="item.status != 'NOT_PRINTED'" /> -->
                <b-form-checkbox v-model="item.checked" :disabled="item?.bankCode === 'MSBVA'" />
              </template>
              <template #cell(region)="{ item }">
                {{ getRegionNameNew(item?.regionCode) }}
              </template>
              <template #cell(integratedMethod)="{ item }">
                {{
                  item?.integratedMethod === 'VAMC'
                    ? 'VA trực tiếp'
                    : item?.integratedMethod === 'VANP'
                      ? 'VA gián tiếp'
                      : item?.integratedMethod
                }}
              </template>
              <template #cell(merchant)="{ item }">
                <div>
                  <b-link
                    :href="`/list-mc/${item.merchantAccountInfo?.customerId}`"
                    size="sm"
                    target="_blank"
                  >
                    {{ item.merchantAccountInfo?.name || '' }}
                  </b-link>
                </div>
                <div>
                  <a :href="`mailto:${item.merchantAccountInfo?.email}`">{{
                    item.merchantAccountInfo?.email
                  }}</a>
                </div>
                <div>
                  {{ item.merchantAccountInfo?.businessRegistrationAddress }}
                </div>
                <!-- <div><strong><span style="color: #13569F;">ID</span>:</strong> {{ item.customerId }}</div> -->
                <div v-if="item.merchantAccountInfo?.businessRegistrationNumber">
                  <strong><span style="color: #de0000">GPĐKKD</span>:</strong>
                  {{ item.merchantAccountInfo?.businessRegistrationNumber }}
                </div>
                <div>
                  <span class="text-muted">Vùng:</span>
                  {{ getRegionNameNew(item?.regionCode) }}
                </div>
              </template>

              <template #cell(vaInfo)="{ item }">
                <div>{{ item.mobileUserId }}</div>
              </template>

              <template #cell(bankCode)="{ item }">
                {{ getBankName(item?.bankCode) }}
              </template>

              <template #cell(vaAccount)="{ item }">
                <div><strong class="text-muted">Tên:</strong> {{ item?.name }}</div>
                <div>
                  <strong class="text-muted">MobileUser:</strong>
                  {{ item?.mobileUserName }}
                </div>
                <div>
                  <strong class="text-muted">TK:</strong>
                  {{ item.bankAccountNumber }}
                </div> </template
              >>

              <template #head(provinceDistrict)>
                Tỉnh/Thành phố <br />
                Quận/Huyện
              </template>
              <template #cell(provinceDistrict)="{ item }">
                <div>{{ item?.merchantAccountInfo?.provinceName }}</div>
                <div>{{ item?.merchantAccountInfo?.districtName }}</div>
              </template>

              <template #cell(time)="{ item }">
                <div v-if="item?.lastModifiedPrinted">
                  <strong class="text-muted">In</strong>:
                  {{ item?.lastModifiedPrinted | formatDate('HH:mm DD/MM/YYYY') }}
                </div>
                <div v-if="item?.lastModifiedPasted">
                  <strong class="text-muted">Dán</strong>:
                  {{ item?.lastModifiedPasted | formatDate('HH:mm DD/MM/YYYY') }}
                </div>
                <div v-if="item?.lastModifiedStop">
                  <strong class="text-muted">Ngừng sử dụng</strong>:
                  {{ item?.lastModifiedStop | formatDate('HH:mm DD/MM/YYYY') }}
                </div>
              </template>

              <template #cell(qrCode)="{ item }">
                <div><strong>qrId:</strong> {{ item?.qrId }}</div>
                <div><strong>qrCode:</strong> {{ item?.qrCode }}</div>
              </template>

              <template #cell(qrImage)="{ item }">
                <div
                  class="qr-code-container"
                  style="cursor: pointer"
                  @click="
                    showQRCodeModal(
                      item.qrCode,
                      item.bankCode,
                      item.virtualAccount,
                      item?.integratedMethod,
                      true
                    )
                  "
                >
                  <QRCodeStyling
                    logo=""
                    :data="item.qrCode"
                    :size="80"
                    :imageOptions="{
                      crossOrigin: 'anonymous',
                      margin: 3,
                      imageSize: 0.6,
                      hideBackgroundDots: true,
                    }"
                  />
                </div>
              </template>

              <template #cell(times)="{ item }">
                {{ formatDate(item.createdDate) }}
              </template>
              <template #cell(qrRequester)="{ item }">
                <div v-if="item?.qrRequester">
                  <p>{{ item?.qrRequester?.name }}</p>
                  <p>{{ item?.qrRequester?.email }}</p>
                </div>
              </template>

              <template #cell(virtualAccount)="{ item }">
                <p>{{ item?.virtualAccount }}</p>
                <p>Mã lô: {{ item?.lotIn }}</p>
                <b-link
                  :href="`customer-support/account/${item.merchantAccountId}`"
                  target="_blank"
                >
                  <p>{{ item?.merchantAccountEmail }}</p>
                  <p>
                    {{ item?.merchantAccountName }}
                  </p>
                </b-link>
              </template>

              <template #cell(isUsed)="{ item }">
                {{ item.isUsed ? 'Đã sử dụng' : 'Chưa sử dụng' }}
              </template>

              <template #cell(status)="{ item }">
                <div class="text-center">
                  <span :class="`badge ${getStatusClass(item.status)}`">
                    {{ getStatusName(item.status) }}
                  </span>
                </div>
              </template>

              <template #cell(actions)="{ item }">
                <div v-if="dataPermission && dataPermission.includes('CNPS_CSS_VA_QR_DETAIL')">
                  <b-link
                    :href="`/customer-support/account-qr-va/${item.id}/detail-sticker`"
                    target="_blank"
                    size="sm"
                    >Chi tiết Sticker</b-link
                  >
                </div>
                <div
                  v-if="
                    dataPermission &&
                    dataPermission.includes('CNPS_CSS_VA_QR_PRINT') &&
                    item?.bankCode !== 'MSBVA'
                  "
                >
                  <!-- <b-link @click="downloadQR(item, listPrintQr[0]?.id || 'K_65_62')" size="sm">Tải mã QR</b-link> -->
                  <b-link
                    type="button"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style="position: relative"
                  >
                    {{ isLoadingQr ? 'Loading...' : 'Tải mã QR' }}
                  </b-link>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item"
                      v-for="(i, index) in listPrintQr"
                      :key="index"
                      href="#"
                      @click="downloadQR(item, i?.id)"
                      >{{ i?.text }}</a
                    >
                  </div>
                  <!-- <div>
                    <b-link @click="downloadQR(item, 'K_65_62')"
                      >Kích thước 65x62</b-link
                    >
                  </div>
                  <div>
                    <b-link @click="downloadQR(item, 'K_80_78')"
                      >Kích thước 80x78</b-link
                    >
                  </div> -->
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-form-group class="mb-0" style="padding: 17px">
                <b-form-select
                  v-model="pagination.limit"
                  :options="pageOptions"
                  @change="onItemsPerPageChange"
                ></b-form-select>
              </b-form-group>
              <b-pagination
                v-model="pagination.page"
                :total-rows="totalCount"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
      <PopupEdit ref="popupEditRef" @update-table="refreshTable" />
      <!-- <iframe v-if="pdfUrl" :src="pdfUrl" style="width: 100%; height: 100vh;"></iframe> -->
      <b-modal id="changeStatusModal" @ok="UpdateStatus">
        <template #modal-title> Thay đổi trạng thái </template>

        <div>
          <div>
            Trạng thái hiện tại:
            <span :class="`badge ${getStatusClass(currentStatus)}`">
              {{ getStatusName(currentStatus) }}
            </span>
          </div>
          <b-form-group label="Chọn trạng thái mới:">
            <b-form-select
              v-model="newStatus"
              :options="statusOptions"
              text-field="text"
              value-field="id"
            ></b-form-select>
          </b-form-group>
        </div>

        <template #modal-footer="{ ok, cancel }">
          <b-button variant="secondary" @click="cancel">Hủy</b-button>
          <b-button variant="primary" :disabled="newStatus == 'PASTED_QR'" @click="ok"
            >Lưu thay đổi</b-button
          >
        </template>
      </b-modal>
      <b-modal
        id="qr-code-modal"
        title="Ảnh QR"
        size="md"
        centered
        hide-footer
        v-model="showQRCodeCheck"
      >
        <showQr
          text="NEXTPAY"
          :bankUser="bankUser"
          :qrCode="qrCode"
          logo=""
          :bank="qrId"
          :qr-size="qrSize"
          :integrated-method="integratedMethod"
        ></showQr>
      </b-modal>
    </div>
    <!-- Add the modal component at the end of your template -->
    <RequestQrModal
      ref="requestQrModalRef"
      :dataConfigRegion="dataConfigRegion"
      :listBankCode="listBankCode"
      :listPrintQr="listPrintQr"
      @request-successful="onRequestSuccess"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  import { CommonService } from '@/services/common.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { DownloadQrVa, ChangeQrStatus, SearchQrVa } from '@/services/customer-support/account'
  import { SearchByCode } from '@/services/customer-support/location'
  import { showMess } from '@/config/utils'
  import PopupEdit from './components/PopupEdit.vue'
  // import { level3LocationDetails } from '@/config/manhthdConfigs'
  // import DateRangePicker from 'vue2-daterange-picker'
  // import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import TotalCount from '@/components/cskh/Counts.vue'
  // import VueQrcode from "vue-qrcode-component";
  import QRCodeStyling from './qrCodeStyling.vue'
  import showQr from './components/showQr.vue'
  import { getBrowserName } from '@/utils/util'
  import RequestQrModal from './components/modalCreateQR.vue'

  export default {
    components: {
      RequestQrModal,
      PopupEdit,
      // DateRangePicker
      TotalCount,
      // VueQrcode,
      QRCodeStyling,
      showQr,
    },
    data() {
      return {
        filters: {},

        isLoading: true,
        isLoadingQr: false,
        selectAll: false,
        dataConfigRegion: [],
        dataProvince: [],
        dataConfigRegionMC: [],
        dataProvinceMC: [],
        dataDistrict: [],
        dataConfigMcc: [],
        dataManager: [],
        listUser: [],
        listStateSearch: [],
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        statusOptions: [],
        listQrStatus: [
          { id: 'NEW', text: 'Mới' },
          { id: 'PRINTED', text: 'Đã in' },
        ],
        listBankCode: [],
        changeStatusId: '',
        newStatus: null,
        currentStatus: null,
        qrId: null,
        qrCode: null,
        bankUser: null,
        showQRCodeCheck: false,
        qrSize: 450,
        integratedMethod: '',

        // config
        dataConfigService: [],
        sourceCreate: Config.sourceCreate,
        localeData: Config.localeData,
        ownershipType: [], // systemConfig.ownershipType,

        listMcType: [
          { id: 0, text: 'Tất cả' },
          {
            id: 'MC_KEY',
            text: 'Merchant key',
          },
          {
            id: 'MC_NORMAL',
            text: 'Merchant thường',
          },
        ],
        totalCount: 0,
        fields: [
          {
            key: 'checkbox',
            label: '',
            sortable: false,
            thStyle: 'width: 30px; text-align: center',
          },
          {
            key: 'virtualAccount',
            label: 'Tài khoản VA',
            sortable: false,
            thStyle: 'min-width: 150px, max-width: 200px',
            tdClass: 'td_class',
          },
          {
            key: 'bankCode',
            label: 'Ngân hàng',
            sortable: false,
          },
          {
            key: 'isUsed',
            label: 'Đã sử dụng',
            sortable: false,
          },
          {
            key: 'printCount',
            label: 'Số lần in',
            sortable: false,
          },

          {
            key: 'region',
            label: 'Vùng',
            sortable: false,
            thStyle: 'min-width: 150px, max-width: 200px',
            tdClass: 'td_class',
          },
          {
            key: 'qrRequester',
            label: 'Người tạo',
            sortable: false,
            thStyle: 'min-width: 100px, max-width: 200px',
            tdClass: 'td_class',
          },
          {
            key: 'qrImage',
            label: 'Ảnh QR',
            sortable: false,
            thStyle: 'min-width: 80px',
            tdClass: 'qr_class',
          },

          {
            key: 'status',
            label: 'Trạng thái',
            sortable: false,
            thStyle: 'min-width: 80px',
          },

          {
            key: 'actions',
            label: 'Thao tác',
            sortable: false,
            thStyle: 'min-width: 80px',
          },
        ],
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        totals: {
          suspend: 0,
          active: 0,
        },
        dataTable: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
        listPrintQr: [],
      }
    },

    filters: {
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    async mounted() {
      await this.configSystem()
      if (this.dataPermission.includes('CNPS_CSS_QR_LIST')) {
        await this.getRegions()
        await this.getManager()
        await this.getListStaffBySuperior()
        await this.buildQuery()
        await this.getMcRegions()
        // await this.getMcDistrict()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      checkAllMSBVA() {
        if (!this.dataTable || this.dataTable.length === 0) {
          return false // Trường hợp mảng rỗng, trả về false
        }

        return this.dataTable.every(item => item.bankCode === 'MSBVA')
      },
      getStatusName() {
        return status => {
          const objStatus = this.listQrStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listQrStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      getRegionName() {
        return region => {
          const objRegion = this.dataConfigRegionMC.find(s => s.id === region)
          return objRegion ? objRegion.text : region
        }
      },
      getProvinceMerchantName() {
        return province => {
          const objProvince = this.dataProvinceMC.find(s => s.id === province)
          return objProvince ? objProvince.text : province
        }
      },
      getDistrictName() {
        return district => {
          const objDistrict = this.dataDistrict.find(s => s.id === district)
          return objDistrict ? objDistrict.text : district
        }
      },
      hasCheckeds() {
        return this.dataTable.some(row => row.checked)
      },
      mapBankName() {
        return this.listBankCode.reduce((map, item) => {
          map[item.id] = item.text
          return map
        }, {})
      },
      getBankName() {
        return bank => this.mapBankName[bank] || ''
      },
    },
    methods: {
      getRegionNameNew(code) {
        const objStatus = this.dataConfigRegion?.find(s => s.id === code)
        return objStatus ? objStatus.text : code
      },
      showRequestQrModal(e) {
        this.$refs.requestQrModalRef.show()
      },
      onRequestSuccess() {
        this.refreshTable()
      },

      onItemsPerPageChange() {
        this.pagination.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
        this.refreshTable()
      },
      refreshTable() {
        this.buildQuery()
      },

      showQRCodeModal(qrCode, qrId, user, integratedMethod, newVal) {
        if (newVal) {
          this.showQRCodeCheck = newVal
          this.qrCode = qrCode
          this.qrId = qrId
          this.bankUser = user
          this.integratedMethod = integratedMethod
        } else {
          this.showQRCodeCheck = false
          this.qrCode = ''
          this.qrId = ''
          this.bankUser = ''
          this.integratedMethod = ''
        }
      },

      // nút bỏ lọc
      async clearSearch() {
        this.selectAll = false
        this.pagination.page = 1

        this.filters = {}

        this.dataProvince = []
        this.dataProvinceMC = []
        this.dataDistrict = []
        await this.buildQuery()
      },

      async buildQuery() {
        const conditions = []
        const conditionsMap = {}

        const textSearch = this.filters.virtualAccount?.trim()
        textSearch && conditions.push(`{virtualAccount} LIKE '''${textSearch}'''`)

        const lotInSearch = this.filters.lotIn?.trim()
        lotInSearch && conditions.push(`{lotIn} LIKE '''${lotInSearch}'''`)

        this.filters.regionCode &&
          this.filters.regionCode !== '0' &&
          (conditionsMap.regionCode = this.filters.regionCode)

        this.filters.qrRequesterBy &&
          this.filters.qrRequesterBy !== '0' &&
          conditions.push(`{qrRequesterBy} == '''${this.filters.qrRequesterBy}'''`)

        this.filters.isUsed &&
          this.filters.isUsed !== '0' &&
          conditions.push(`{isUsed} == ${this.filters.isUsed}`)

        this.filters.status &&
          this.filters.status !== '0' &&
          conditions.push(`{status} == '''${this.filters.status}'''`)

        this.filters.bankCode &&
          this.filters.bankCode !== '0' &&
          conditions.push(`{bankCode} == '''${this.filters.bankCode}'''`)

        this.pagination.queryString = conditions.join(' AND ')
        await this.loadData(conditionsMap)
      },
      async loadData(conditionsMap = {}) {
        try {
          this.isLoading = true
          const searchQuery = {
            count: true,
            // showStaffAssign: true,
            limit: this.pagination.limit,
            page: this.pagination.page,
            queryString: this.pagination.queryString,
            ...conditionsMap,
            sort: {
              direction: this.pagination.sortType,
              properties: [this.pagination.sortField],
            },
          }
          const res = await SearchQrVa(searchQuery)
          if (res.data.listData) {
            this.dataTable = res.data.listData.map(el => {
              return {
                ...el,
                checked: false,
              }
            })
          } else {
            this.dataTable = []
          }
          this.pagination.total = res.data.totalCount ?? 0
          this.totalCount = res.data.totalCount ?? 0
          if (res.data.listCountStatus) {
            this.totals = res.data.listCountStatus
              .filter(item => item.status)
              .sort((a, b) => a.status.localeCompare(b.status))
              .reduce((acc, item) => {
                const status = acc.find(s => s.status === item.status)
                if (status) {
                  status.count += item.count
                } else {
                  const statusObj = this.listQrStatus.find(list => list.id == item.status)
                  acc.push({
                    status: statusObj?.text || item.status,
                    status_class: statusObj?.class ?? 'text-primary',
                    count: item.count,
                  })
                }
                return acc
              }, [])
          } else {
            this.totals = []
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },

      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.selectAll = false
        this.buildQuery()
      },
      // page
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.buildQuery()
      },

      async onPrintQrHandle(qrPrintSize) {
        const dataSentQr = this.dataTable.filter(item => item.checked)
        try {
          this.isLoadingQr = true
          const res = await DownloadQrVa({
            status: 'PRINTED',
            ids: dataSentQr.reduce((arr, item) => {
              arr.push(item.id)
              return arr
            }, []),
            qrPrintSize: qrPrintSize, // Thêm thông tin kích thước
          })
          res &&
            (() => {
              const href = URL.createObjectURL(res)

              switch (getBrowserName()) {
                case 'Chrome':
                  ;(() => {
                    // iframe
                    const iframe = document.createElement('iframe')
                    iframe.style.display = 'none'
                    iframe.src = href
                    document.body.appendChild(iframe)
                    iframe.contentWindow.focus()
                    iframe.contentWindow.onload = () => {
                      iframe.contentWindow.print()
                    }
                  })()
                  break
                case 'Firefox':
                  ;(() => {
                    // download
                    const link = document.createElement('a')
                    link.href = href
                    link.setAttribute('download', 'qr-code-print.pdf')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(href)
                  })()
                  break
                case 'Safari':
                  ;(() => {
                    // new tab
                    const newWindow = window.open(href, '_blank')
                    newWindow &&
                      (() => {
                        newWindow.onload = () => {
                          newWindow.print()
                        }
                      })()
                  })()
                  break
                default:
                  ;(() => {
                    // default new tab
                    const newWindow = window.open(href, '_blank')
                    newWindow &&
                      (() => {
                        newWindow.onload = () => {
                          newWindow.print()
                        }
                      })()
                  })()
              }
            })()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoadingQr = false
        }
      },

      toggleSelectAll() {
        this.dataTable.forEach(item => {
          // Chỉ cập nhật trạng thái checked nếu không phải MSBVA
          if (item.bankCode !== 'MSBVA') {
            item.checked = this.selectAll
          } else {
            // Đảm bảo item MSBVA luôn không được chọn
            item.checked = false
          }
        })
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.code,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.filters.businessProvinceCode = ''
          this.dataProvince = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy vùng mc
      async getMcRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.code,
              text: e.name,
              idForProvice: e.id,
            }
          })
          this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e) {
        try {
          this.filters.provinceCode = ''
          this.filters.districtCode = ''
          this.dataDistrict = []
          this.dataProvinceMC = []
          const data = await StaffService.getProvinceRegion({
            regionId: [this.dataConfigRegionMC.find(data => data.id == e).idForProvice],
          })
          if (data.data.length > 0) {
            this.dataProvinceMC = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvinceMC.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy quận mc
      async getMcDistrict(event) {
        const data = await SearchByCode({ code: event })
        if (data.data.length > 0) {
          this.dataDistrict = data.data
            .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
            .map(e => {
              return {
                id: e.locationCode,
                text: e.localName,
              }
            })
        }
        this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
      },
      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // Lấy quản lý
      async getManager() {
        try {
          const data = await StaffService.superiors()
          if (data.success) {
            this.dataManager = data.data.map(e => {
              return {
                id: e.id,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.dataManager.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.ownershipType = data.data.ownershipType.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                }
              })

              this.ownershipType.unshift({ id: '0', text: 'Tất cả' })

              this.listPrintQr = data.data.cssVaQrPrintSize.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigService = data.data.services.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigService.unshift({ id: '0', text: 'Tất cả' })
              this.getListService()
              this.dataConfigMcc = data.data.businessFields.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigMcc.unshift({ id: '0', text: 'Tất cả' })
              // this.listQrStatus = data.data.qrStatus.map((e) => {
              //   return {
              //     ...e,
              //     id: e.code,
              //     text: e.name
              //   }
              // })
              // this.listQrStatus.unshift({ id: '0', text: 'Tất cả' })
              this.statusOptions = data.data.qrStatus.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.statusOptions = this.statusOptions.filter(e => e.id != 'PASTED_QR')
              this.listBankCode = data.data.banks.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.listBankCode.unshift({ id: '0', text: 'Tất cả' })
              this.listMcStatus = data.data.merchantAccountStatus.map(e => {
                return {
                  ...e,
                  id: e.code,
                  text: e.name,
                }
              })
              this.listMcStatus.unshift({ id: '0', text: 'Tất cả' })
            }
          })
          .catch(error => console.error(error))
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              this.dataConfigService = data[0].detail.map(e => {
                return {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
              })
            }
            // ListState
            this.listStateSearch = [{ id: 0, text: 'Tất cả' }, ...this.listState]
          }
        } catch (error) {
          console.log(error)
        }
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
      changeStatus(item) {
        this.changeStatusId = item.id
        this.newStatus = item.status
        this.currentStatus = item.status
        this.$bvModal.show('changeStatusModal')
      },
      async UpdateStatus() {
        // todo
        if (this.newStatus && this.changeStatusId) {
          const res = await ChangeQrStatus({
            status: this.newStatus,
            ids: [this.changeStatusId],
          })
          if (res.result) {
            this.buildQuery()
            this.newStatus = null
            this.currentStatus = null
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        }
      },
      async downloadQR(item, qrPrintSize) {
        // Giá trị mặc định
        try {
          this.isLoadingQr = true
          const res = await DownloadQrVa({
            status: 'PRINTED',
            ids: [item.id],
            qrPrintSize: qrPrintSize, // Thêm thông tin kích thước
          })
          res &&
            (() => {
              const href = URL.createObjectURL(res)
              // download QR
              const link = document.createElement('a')
              link.href = href
              link.setAttribute('download', 'qr-code-print.pdf')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              URL.revokeObjectURL(href)
            })()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoadingQr = false
        }
      },
    },
  }
</script>
<style scoped>
  .total_check {
    /* margin: 5px; */
    /* text-align: center; */
    display: flex;
    text-align: center;
  }

  .total_label {
    color: #8a9298;
    font-size: 14px;
  }

  .total_field {
    font-size: 20px;
  }
</style>
<style>
  .td_class {
    min-width: 150px;
    max-width: 200px;
  }

  .qr_class {
    min-width: 80px;
    max-width: 120px;
  }

  .time_class {
    min-width: 100px;
    max-width: 200px;
  }

  .nowrap {
    white-space: nowrap;
  }

  .tooltip-class .tooltip-inner {
    background-color: rgb(253, 253, 253);
    color: #319db5;
    text-align: left;
    max-height: 150px;
    max-width: 200px;
    overflow-y: auto;
    border: 1px solid;
  }

  .title_h {
    font-size: 20px;
    font-weight: 400;
    line-height: 23.44px;
    text-align: left;
  }

  .dropdown-toggle::after {
    position: revert;
  }
</style>
